module.exports = __webpack_public_path__ + "static/media/CAKE.bde645a5.png";